import React from "react";
import { Box, Typography } from "@mui/material";
import whiteVoteIcon from "../../../../assets/customerAssets/icons/whiteVoteIcon.svg";
import { useSelector } from "react-redux";
import User_D from "../../../../assets/customerAssets/user_D.jpeg";

const Position = ({ index, leaderboard, club_logo }) => {
  const user = useSelector((state) => state.user);
  return (
    <Box
      className={
        index == 0
          ? "position-main first"
          : index == 1
            ? "position-main second"
            : "position-main third"
      }
    >
      <Box sx={{ position: "relative" }} className="content-wrapper">
        <Box className="img-wrapper">
          <img
            src={
              leaderboard[index]?.club_img ||
              leaderboard[index]?.goalUserDetails?.profile_img ||
              User_D
            }
            style={{ width: "100%", height: "100%" }}
          />
        </Box>
        <Box className="content">
          <Box className="floating-content view-club">
            <Typography component={"span"}>
              {index == 0 ? "1" : index == 1 ? "2" : "3"}
            </Typography>
          </Box>
          <Typography component={"span"} sx={{ marginTop: "28px" }}>
            {leaderboard[index].goal_scorer}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "start",
              justifyContent: "center",
              gap: "2px",
            }}
          >
            <img src={whiteVoteIcon} height={20} width={20} />
            <Typography component={"span"}>
              {leaderboard[index].voteCount} Votes
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Position;
